import React, { Component, PropTypes } from 'react';

import Menu from './menu/menu';
import JobList from './jobList/jobList';
import Slider from './slider/slider';

import css from './globalNav.scss';
import lorem from '../../utils/lorem';

export default class GlobalNav extends Component {
	static propTypes = {
		menuActive: PropTypes.bool.isRequired,
		mainMenu: PropTypes.object.isRequired,
		subMenu: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		selectedMenu: PropTypes.object,
		browser: PropTypes.object.isRequired,
	};

	render() {
		let selMenu = this.props.selectedMenu;
		let slideContext = (selMenu && typeof selMenu.type === 'string') ? selMenu.type : '';

		return (
			<nav className={this.hiddenClass()}>
				<div className='app-container--width globalnav__container'>
					<div className='globalnav-menu'>
						<Menu {...this.props} />
					</div>
					<div className='globalnav-sidebar'>
						<div className='globalnav-sidebar__jobs'>
							<JobList dispatch={this.props.dispatch} />
						</div>
						<div className='globalnav-sidebar__context'>
							<Slider browser={this.props.browser} {...this.props} context={slideContext} menuActive={this.props.menuActive} />
						</div>
					</div>
				</div>
			</nav>
		);
	}

	isMenuActive() {
		return this.props.menuActive;
	};

	hiddenClass() {
		return this.isMenuActive() ? 'globalnav' : 'globalnav globalnav--hide';
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/globalNav.js
 **/